"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.MediaItems = exports.ElementsEmpty = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'block',
  position: 'relative',
  boxSizing: 'border-box',
  width: '100%',
  paddingLeft: theme.spacing(3),
  overflow: 'hidden',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(8)
  }
}));
const ElementsEmpty = exports.ElementsEmpty = (0, _mui.styled)('div')(({
  theme
}) => ({
  gridRow: '1 / 2',
  alignSelf: 'center',
  width: 50,
  scrollSnapAlign: 'end',
  [theme.breakpoints.up('lg')]: {
    gridRow: '1 / 3',
    width: 250
  }
}));
const MediaItems = exports.MediaItems = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isShort,
  scrollable
}) => ({
  display: 'grid',
  boxSizing: 'border-box',
  gridAutoColumns: '1fr',
  gridAutoFlow: 'column',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '1fr',
  gap: theme.spacing(3),
  alignItems: 'start',
  justifyItems: 'start',
  overflowX: 'scroll',
  scrollBehavior: 'smooth',
  scrollSnapType: 'x mandatory',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  ...(!scrollable && {
    overflowX: 'hidden',
    scrollSnapType: 'none'
  }),
  '&::-webkit-scrollbar': {
    width: 0,
    height: 0
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateRows: '1fr 1fr',
    gap: theme.spacing(6),
    justifyItems: 'center',
    overflowX: 'hidden',
    scrollSnapType: 'none'
  },
  ...(isShort && {
    [theme.breakpoints.up('lg')]: {
      gridAutoColumns: 'auto',
      gridTemplateColumns: 'auto',
      justifyContent: 'center'
    }
  })
}));
